// @flow

import { beginRequest, completeRequest } from "@store/utils";
import type { AlertsState } from "./types";

const startRequest = beginRequest(["requestsInProgress"]);

const finishRequest = completeRequest(["requestsInProgress"]);

export const onGetAlerts = (state: AlertsState) => () => startRequest(state);

export const onGetAlertsSuccess = (state: AlertsState) => ({ payload }: *) => ({
  ...state,
  ...finishRequest(state),
  error: null,
  list: payload,
});

export const onGetAlertsError = (state: AlertsState) => ({ payload }: *) => ({
  ...state,
  ...finishRequest(state),
  success: false,
  error: payload,
});
